
import type { RegularFilterSelectedValues } from '../../models'

import { defineComponent, getCurrentInstance, onMounted } from 'vue'
import FiltersAside from '../../components/filters/filters-aside.component.vue'
import RelatedPromptsMetrics from '../../components/related-prompts/related-prompts-metrics.component.vue'
import { EpbButton, EpbText, SearchBox } from '../../components/shared'
import { EpbAnimatedBackground } from '../../components/shared/epb-animated-background'
import { useRelatedPrompts } from '../../composables'
import { FeatureIdEnum } from '../../enums'
import { ROUTER_CONSTS } from '../../router/router.consts'

export default defineComponent({
  name: 'RelatedPromptsLanding',
  components: {
    EpbAnimatedBackground,
    EpbButton,
    EpbText,
    FiltersAside,
    RelatedPromptsMetrics,
    SearchBox,
  },
  setup(_, ctx) {
    const baseClass = 'related-prompts-landing'

    const {
      proxy: { $router },
    } = getCurrentInstance()

    const { context, filters, messages, isSelectedMandatoryFilters, setQuery, setFiltersValues } =
      useRelatedPrompts(ctx)

    const updateFilters = (selectedValues: Record<string, RegularFilterSelectedValues>): void => {
      setFiltersValues(selectedValues)
    }

    const search = (query: string): void => {
      setQuery(query)
      $router.push({ name: ROUTER_CONSTS.routes[FeatureIdEnum.RELATED_PROMPTS].preview })
    }

    const goToOverview = (): void => {
      $router.push({ name: ROUTER_CONSTS.routes[FeatureIdEnum.RELATED_PROMPTS].overview })
    }

    onMounted(() => setQuery(''))

    return {
      baseClass,
      context,
      filters,
      isSelectedMandatoryFilters,
      messages,
      updateFilters,
      search,
      goToOverview,
    }
  },
})
